export { AuthenticationComponent } from './authentication.component';
